import { ApplicationRef, ComponentFactoryResolver, Injectable, Injector } from '@angular/core';
import { MmBimService } from '../../mm-bim.service';
import { PromptDialogService } from '@mydocma/component-library/src/lib/prompt-dialog';
import { TranslateService } from '@ngx-translate/core';
import { MmBimDialogComponent } from './bim-dialog.component';

@Injectable()
export class MmBimDialogService {

  private bimViewComponentRef: any;


  constructor(private mmBimService: MmBimService,
              private readonly dialogService: PromptDialogService,
              private translateService: TranslateService,
              private componentFactoryResolver: ComponentFactoryResolver,
              private injector: Injector,
              private appRef: ApplicationRef) {

  }

  public IsOpen(): boolean {
      return !!this.bimViewComponentRef;
  }

  public async openBimDialog(startInCreationMode = false) {
    if (!this.mmBimService?.bimPlans?.length) {
      await this.dialogService.showNotificationDialog({
        title: this.translateService.instant('MM.bimViewer.noBimModelAvailableDialog.title'),
        subTitle: this.translateService.instant('MM.bimViewer.noBimModelAvailableDialog.subTitle'),
        content: this.translateService.instant('MM.bimViewer.noBimModelAvailableDialog.content')
      });
      return;
    }

    if (this.bimViewComponentRef) {
      return;
    }
    const options = { startInCreationMode };
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(MmBimDialogComponent);
    const componentRef = componentFactory.create(this.injector);
    this.bimViewComponentRef = componentRef;
    componentRef.instance.startInCreationMode = startInCreationMode;

    const componentNativeElement = componentRef.location.nativeElement;
    this.appRef.attachView(componentRef.hostView);

    const appFrameElement = document.querySelector('.app-frame');
    appFrameElement.parentNode.append(componentNativeElement, appFrameElement.nextSibling);

    this.mmBimService.IsBimViewOpen = this.IsOpen();
  }

  public async closeBimDialog() {
    if (this.bimViewComponentRef) {
      const componentNativeElement = this.bimViewComponentRef.location.nativeElement;
      componentNativeElement.parentNode.removeChild(componentNativeElement);
      this.bimViewComponentRef.destroy();
      this.bimViewComponentRef = null;
      this.mmBimService.IsBimViewOpen = this.IsOpen();
    }
  }
}
